import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function TomosSection() {
  const tomos = [{
    emoji: '🪞',
    title: 'Tomo 1 — El Espejo',
    subtitle: 'Autoestima e Identidad',
    desc: 'Quién soy, cómo me hablo, qué pienso de mí. Los 4 pilares de una autoestima que no depende de likes ni de la opinión ajena.',
    color: 'from-emerald-500/20 to-emerald-900/20',
    border: 'border-emerald-500/30'
  }, {
    emoji: '🌋',
    title: 'Tomo 2 — El Volcán',
    subtitle: 'Emociones e Inteligencia Emocional',
    desc: 'Ira, tristeza, miedo, culpa. Cómo identificarlas, nombrarlas y usarlas en lugar de ser controlado por ellas.',
    color: 'from-red-500/20 to-red-900/20',
    border: 'border-red-500/30'
  }, {
    emoji: '🛡️',
    title: 'Tomo 3 — El Escudo',
    subtitle: 'Mundo Digital y Bienestar',
    desc: 'Redes, comparación, presión digital. Cómo usar la tecnología sin que la tecnología te use a vos.',
    color: 'from-purple-500/20 to-purple-900/20',
    border: 'border-purple-500/30'
  }, {
    emoji: '⚓',
    title: 'Tomo 4 — El Timón',
    subtitle: 'Ansiedad y Regulación',
    desc: 'Ansiedad, estrés, rumiación. Kit completo de herramientas para navegar la mente en momentos difíciles.',
    color: 'from-blue-500/20 to-blue-900/20',
    border: 'border-blue-500/30'
  }, {
    emoji: '🌉',
    title: 'Tomo 5 — El Puente',
    subtitle: 'Relaciones y Comunicación',
    desc: 'Vínculos, conflictos, límites, conversaciones difíciles. Cómo conectar de verdad sin explotar ni ceder.',
    color: 'from-orange-500/20 to-orange-900/20',
    border: 'border-orange-500/30'
  }, {
    emoji: '🗺️',
    title: 'Tomo 6 — El Mapa',
    subtitle: 'Propósito y Toma de Decisiones',
    desc: 'Valores, dirección, decisiones. Cómo construir una brújula interna para no perderse en la adolescencia.',
    color: 'from-yellow-500/20 to-yellow-900/20',
    border: 'border-yellow-500/30'
  }];
  const includes = ['Teoría clara adaptada al contexto real de hoy', 'Ejercicios prácticos paso a paso', 'Scripts y frases concretas para situaciones reales', 'Protocolos de intervención para padres y docentes', 'Actividades individuales y grupales', 'Casos y ejemplos del día a día adolescente', 'Guía de uso para adultos al inicio de cada tomo', '100% lenguaje cercano, sin tecnicismos innecesarios'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-800" data-id="element-284">
      <div className="max-w-7xl mx-auto" data-id="element-285">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-286">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold-500/20 text-gold-400 mb-6 text-3xl" data-id="element-287">
            🏆
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" data-id="element-288">
            MI ESPACIO INTERIOR MEGAPACK
          </h2>
          <p className="text-xl text-blue-300 font-medium mb-2" data-id="element-289">
            6 Tomos + 6 Bonos — 12 a 18 años
          </p>
          <p className="text-lg text-slate-400" data-id="element-290">
            360+ páginas — Todo resuelto.
          </p>
        </motion.div>

        <div className="text-center mb-12" data-id="element-291">
          <h3 className="text-2xl font-bold text-white" data-id="element-292">
            📚 6 TOMOS COMPLETOS
          </h3>
          <p className="text-slate-400 mt-2" data-id="element-293">12 a 18 años — 6 TOMOS</p>
        </div>

        {/* Tomo Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-294">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          delay: index * 0.05,
          duration: 0.3
        }} className={`bg-gradient-to-b ${tomo.color} border ${tomo.border} rounded-2xl p-6 backdrop-blur-sm hover:scale-[1.02] transition-transform duration-300`} data-id="element-295">
              <div className="text-4xl mb-4" data-id="element-296">{tomo.emoji}</div>
              <h4 className="text-xl font-bold text-white mb-1" data-id="element-297">
                {tomo.title}
              </h4>
              <p className="text-sm font-semibold text-slate-300 mb-4 pb-4 border-b border-white/10" data-id="element-298">
                {tomo.subtitle}
              </p>
              <p className="text-slate-300 text-sm leading-relaxed" data-id="element-299">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>

        {/* Cada tomo incluye */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.3
      }} className="bg-navy-900 border border-navy-700 rounded-2xl p-6 md:p-12 max-w-4xl mx-auto" data-id="element-300">
          <h4 className="text-2xl font-bold text-center mb-8" data-id="element-301">
            Cada tomo incluye:
          </h4>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-302">
            {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-303">
                <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-304" />
                <span className="text-slate-300" data-id="element-305">{item}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}